import React from 'react';
import { HeroSection } from '../components/sections/HeroSection';
import { WhoSection } from '../components/sections/WhoSection';
import { ProblemSection } from '../components/sections/ProblemSection';
import { TrapsSection } from '../components/sections/TrapsSection';
import { SolutionReveal } from '../components/sections/SolutionReveal';
import { SystemBreakdown } from '../components/sections/SystemBreakdown';
import { Deliverables } from '../components/sections/Deliverables';
import { ResultsSection } from '../components/sections/ResultsSection';
import { ObjectionsSection } from '../components/sections/ObjectionsSection';
import { PricingSection } from '../components/sections/PricingSection';
import { StickyCtaBar } from '../components/StickyCtaBar';
export function SalesPage() {
  return <div className="min-h-screen bg-neutral-950 text-neutral-200 selection:bg-red-900 selection:text-white font-sans antialiased" data-id="element-180">
      <HeroSection data-id="element-181" />
      <WhoSection data-id="element-182" />
      <ProblemSection data-id="element-183" />
      <TrapsSection data-id="element-184" />
      <SolutionReveal data-id="element-185" />
      <SystemBreakdown data-id="element-186" />
      <Deliverables data-id="element-187" />
      <ResultsSection data-id="element-188" />
      <ObjectionsSection data-id="element-189" />
      <PricingSection data-id="element-190" />
      <StickyCtaBar data-id="element-191" />

      <footer className="py-8 text-center text-neutral-600 text-sm bg-black" data-id="element-192">
        <p data-id="element-193">
          © {new Date().getFullYear()} No Puedo Renunciar. Todos los derechos
          reservados.
        </p>
      </footer>
    </div>;
}